<div *transloco="let t;" class="row onboarding" style="background-image: url('./assets/img/BG/BG-Onboarding.jpg');">
  <div class="col-lg-6 col">
    <div class="chat-container">
      <div class="chat-box">
        <img src="./assets/img/portal-op.png" />
        <div class="chat-box-text">
          <h1 class="title-gradient gradient-pp">{{t('onboarding.nowYourReady')}}</h1>
          <p>{{t('onboarding.readyAdventureMsg')}}</p>
          <p>{{t('onboarding.seeTrainer')}}</p>
          <div class="button-gradient" (click)="openHub()">{{t('onboarding.enterTrainerHub')}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6 col">
    <div class="card">
      <div class="checklist">
        <div class="checklist-item">
          <div class="checkmark-icon">
            <img src="./assets/img/Icon/Checked-primary.svg" />
          </div>
          <div class="checkmark-text">
            <h1>{{t('onboarding.chooseStarter')}}</h1>
            <p>{{t('onboarding.kryptomonUniqueBuyMsg')}}</p>
          </div>
        </div>
        <div class="checklist-item">
          <div class="checkmark-icon">
            <img src="./assets/img/Icon/Checked-primary.svg" />
          </div>
          <div class="checkmark-text">
            <h1>{{t('onboarding.buildStartingPackage')}}</h1>
            <p>{{t('onboarding.determinateStartingItems')}}</p>
          </div>
        </div>
        <div class="checklist-item">
          <div class="checkmark-icon">
            <img src="./assets/img/Icon/Checked-primary.svg" />
          </div>
          <div class="checkmark-text">
            <h1>{{t('shared.checkout')}}</h1>
            <p>{{t('onboarding.getYourKMONMsg')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>